const Numbers = {
    round: (number, base = 100) => {
        return Math.trunc(number * base) / base
    }
}

export default Numbers